// Documentation about the event history and its usage can be found in doc/event-history.md
import { type CustomUIEventDetail, type CustomUIEventEnum } from "@jsmdg/ui-event";
import { type EventHistoryEntry } from "./types";

const MAX_ENTRIES = 50;

const entries: EventHistoryEntry[] = [];

function isEntryOfType<T extends CustomUIEventEnum>(
    entry: EventHistoryEntry,
    type: T,
): entry is EventHistoryEntry<T> {
    return entry.type === type;
}

function pushEvent<T extends CustomUIEventEnum>(type: T, detail: CustomUIEventDetail<T>): void {
    entries.push({ type, detail, timestamp: Date.now() });
    
    if (entries.length > MAX_ENTRIES) {
        window.logToSentry(new Error(`Event history exceeded max size of ${MAX_ENTRIES}. Current size: ${entries.length}`));

        entries.shift();
    }
}

function getEventsByType<T extends CustomUIEventEnum>(
    type: T,
    options?: { olderThan?: number },
): Array<EventHistoryEntry<T>> {
    return entries.filter((entry): entry is EventHistoryEntry<T> => {
        if (!isEntryOfType(entry, type)) {
            return false; 
        }

        if (options?.olderThan !== undefined && entry.timestamp >= options.olderThan) {
            return false;
        }

        return true;
    });
}

if (!window.Evelin.eventHistory) {
    window.Evelin.eventHistory = {
        entries,
        pushEvent,
        getEventsByType,
    };
}

